/**
 * Identidad de la aplicación en un solo lugar.
 *
 * El nombre aparece en la cabecera, en la pestaña del navegador, en el `.ics` que el usuario se
 * descarga y como prefijo de todo lo que se guarda en el navegador. Tenerlo centralizado hace
 * que renombrar la aplicación sea cambiar una constante, en vez de perseguir la cadena por
 * media docena de archivos y olvidarse de uno.
 */
export const APP_NAME = 'Provecho';

/** Identificador estable para claves de almacenamiento y del calendario. */
export const APP_ID = 'provecho';
